import React, {useState} from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {DrawerAppContent} from '../../drawers/drawer-app-content'

const StyledDrawerAppContent = styled(DrawerAppContent)`
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  background-color: var(--mdc-theme-neutral2);
`

const AppBarLayout = ({drawer, appBar, children, ...otherProps}) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  return (
    <div style={{minHeight: '100vh', display: 'flex', flexDirection: 'column'}}>
      <div style={{flexGrow: 1, display: 'flex', flexDirection: 'column'}}>
        <main style={{flex: '1 1', display: 'flex', maxHeight: '100vh'}}>
          {drawer &&
            React.cloneElement(drawer, {
              modal: true,
              isDrawerOpen,
              setIsDrawerOpen
            })}
          <StyledDrawerAppContent {...otherProps}>
            {appBar &&
              React.cloneElement(appBar, {
                isDrawerOpen,
                setIsDrawerOpen
              })}
            {children}
          </StyledDrawerAppContent>
        </main>
      </div>
    </div>
  )
}

AppBarLayout.propTypes = {
  drawer: PropTypes.node,
  appBar: PropTypes.node,
  children: PropTypes.any
}

export {AppBarLayout}
